import { RendererFactory2 } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { LayoutsModule } from '@app/layouts/layouts.module';
import { AppRoutingModule } from '@app/app-routing.module';
import { TitleStrategy, UrlSerializer } from '@angular/router';
import { ModalModule, MODAL_CONFIG_DEFAULT_OVERRIDE } from 'ngx-bootstrap/modal';
import { XUrlSerializerService } from '@app/core/services/x-url-serializer.service';
import { ContentTypeInterceptor } from '@app/core/interceptors/content-type.interceptor';
import { AppComponent } from './app.component';
import { registerLocaleData } from '@angular/common';
import localeRu from '../locale/locales/ru';
import localeRuExtra from '@angular/common/locales/extra/ru';

registerLocaleData(localeRu, 'ru', localeRuExtra);

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule.withServerTransition({ appId: 'sportplusbot' }),
        LayoutsModule,
        AppRoutingModule,
        ModalModule.forRoot(),
        HttpClientModule,
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: ContentTypeInterceptor, multi: true },
        { provide: UrlSerializer, useClass: XUrlSerializerService },
        { provide: 'LOCALSTORAGE', useFactory: getLocalStorage },
        { provide: 'SESSIONSTORAGE', useFactory: getSessionStorage },
        { provide: 'TGBOT', useFactory: getWebApp },

        {
            provide: MODAL_CONFIG_DEFAULT_OVERRIDE, useValue: {
                animated: false,
            }
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }


export function getLocalStorage() {
    return (typeof window !== "undefined") ? window.localStorage : null;
}
export function getSessionStorage() {
    return (typeof window !== "undefined") ? window.sessionStorage: null;
}

export function getWebApp() {
    let w:any =window
    return w.Telegram ? w.Telegram : null;
}
